const TRANSLATIONS_FETCHED = 'TRANSLATIONS_FETCHED';
const LOCALE_CHANGED = 'LOCALE_CHANGED';
const LANGUAGE_SELECTED = 'LANGUAGE_SELECTED';

export { TRANSLATIONS_FETCHED, LOCALE_CHANGED, LANGUAGE_SELECTED };
